import React from 'react';
import { styled } from 'styled-components';
import THEME from '../theme.js';
const Content = (props) => {
    return (React.createElement(ScrollWrapper, { fullHeight: props.fullHeight, className: "content-wrapper", onScroll: props.onScroll },
        React.createElement(ContentStyled, { maxWidth: props.maxWidth }, props.children)));
};
export default Content;
const ScrollWrapper = styled.div `
  height: calc(
    100vh - ${(props) => (props.fullHeight ? 0 : THEME.NAV_TOP_HEIGHT)}px
  );
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
`;
const ContentStyled = styled.div `
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : '1400px')};
  margin: 0 auto;
`;
//# sourceMappingURL=Content.js.map